import styled, { css } from 'styled-components'

const input = css`
  background: transparent;
  border: 1px solid var(--border);
  border-radius: 3px;
  line-height: 22px;
  padding: 13px;
  outline: 0;

  width: 100%;

  &:focus {
    border-color: var(--primary);
  }
`

export const Input = styled.input`
  ${input}
`

export const Textarea = styled.textarea`
  ${input}

  resize: vertical;
`

export const SelectWrapper = styled.div`
  position: relative;

  ::after {
    content: '';
    display: inline-block;
    pointer-events: none;
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg id='SVGRepo_bgCarrier' stroke-width='0'%3E%3C/g%3E%3Cg id='SVGRepo_tracerCarrier' stroke-linecap='round' stroke-linejoin='round'%3E%3C/g%3E%3Cg id='SVGRepo_iconCarrier'%3E%3Crect width='24' height='24' fill='white'%3E%3C/rect%3E%3Cpath d='M17 9.5L12 14.5L7 9.5' stroke='%23000000' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3C/g%3E%3C/svg%3E");
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
  }
`

export const Select = styled.select`
  ${input}

  box-sizing: border-box;
  appearance: none;

  &:not([multiple]) {
    appearance: none;
    padding-right: 40px;
  }

  &:hover {
    cursor: pointer;
  }

  &::-ms-expand {
    display: none;
  }
`
